import { Skeleton } from './Skeleton';

/** Usado antes de sabermos qual página vai renderizar (ex.: checagem de login). */
export function PageLoadingSkeleton() {
  return (
    <div className="cd-page-skeleton" role="status" aria-live="polite" aria-label="Carregando">
      <div className="cd-page-skeleton__header">
        <Skeleton width="8rem" height="0.85rem" />
        <Skeleton width="60%" height="1.75rem" />
        <Skeleton width="80%" height="1rem" />
      </div>
      <Skeleton height="14rem" borderRadius="12px" />
    </div>
  );
}
